const deduceMimeFromName = (name) => {
  const lcName = name.toLowerCase();
  const extension = lcName.substring(lcName.lastIndexOf('.'), lcName.length);
  let ret = '';
  switch (extension) {
    case '.csv':
      ret = 'text/csv';
      break;
    case '.mp4':
    case '.m4v':
      ret = 'video/mp4';
      break;
    case '.json':
      ret = 'application/json';
      break;
    default:
      ret = 'application/unknown';
      break;
  }
  return ret;
};

function resolveMime(file) {
  const { type, name } = file;
  return (type || deduceMimeFromName(name));
}

export { resolveMime as default };
